/*
 * サブシステム名：マスタ管理
 * 機能名：燃費管理
 */

import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import date from '@/ddv2.library/date'
// import validators from '@/rahmen/validators'

// import d2fmt from '@/ddv2.library/utils/formatter'
// import modals from '@/ddv2.library/modals'
// import spsvalidator from '@/ddv2.library/validator4sps'

import header from '@/ddv2.library/header'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdCustomButton from '@/components/DdCustomButton'
import DdDropDown from '@/components/DdDropDown'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdMonthBox from '@/components/DdMonthBox'
import DdMonthBoxInside from '@/components/DdMonthBoxInside'
import DdSpreadSheet from '@/components/DdSpreadSheet'
import DdSubHeader from '@/components/DdSubHeader'
import DdSwitch from '@/components/DdSwitch'
import DdTransparentButton from '@/components/DdTransparentButton'

export default {
  name: 'MstKyuyutankaManagement',
  mixins: [flowMixin],
  components: {
    DdCodeTextBox,
    DdCustomButton,
    DdDropDown,
    DdIconButtonWithTooltip,
    DdMonthBox,
    DdMonthBoxInside,
    DdSpreadSheet,
    DdSubHeader,
    DdSwitch,
    DdTransparentButton
  },
  data: () => ({
    conditions: {},
    isConditionHide: false,
    isEditCategory: false,
    isSearched: false,

    searchedYm: null,
    searchedEigyoshoCd: null,
    searchText: null,
    selected: [],
    headersEigyoshoList: header.mstEigyoshoHeaders,

    // 検索結果保持
    searchResultRow: [],

    // 表示用
    rows: [],

    // ヘッダー
    headers: [],
    nestedHeaders: [],

    // 保存用
    targetKyuyuTankaList: [],

    modeKengen: 0,

    // スプレッドシートオプション
    option: {
      // // テーブル最大高さ
      // tableHeight: '70vh',
      // テーブル最大横幅
      tableWidth: 'inherit',
      // 列追加
      allowInsertColumn: false,
      // 行追加※改行キーのみ
      allowManualInsertRow: false,
      // 列削除
      allowDeleteColumn: false,
      // 行削除
      allowDeleteRow: false,
      // 列ドラッグ
      columnDrag: false,
      // 行ドラッグ
      rowDrag: false,
      // ソート
      columnSorting: false,
      // スクロール有効化
      tableOverflow: true,
      // コンテキストメニュー
      contextmenu: false,
      // セル内HTML無効※ヘッダー改行のため有効
      stripHTML: false,
      // 計算式のサポート
      parseFormulas: false,
      // セル選択時の右下の■ドラッグでのコピー
      selectionCopy: true,
      // CSV出力
      allowExport: false,
      // フィルターオプション
      search: true,
      // ページネーションオプション
      pagination: 25,
      paginationOptions: [10, 25, 50, 100],
      // デフォルト文言変更
      text: {
        show: '1ページ当たりの行数:',
        entries: '',
        showingPage: '全部で {1} ページあります',
        search: 'さらにフリーワードで絞り込む',
        noRecordsFound: '対象データがありません'
      }
    },
    // 画面側からのエラーリスト
    outsideErrorList: []
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      kihonJohoList: 'DDMasters/mstKihonJoho',
      currentKaishaCode: 'users/currentKaishaCode',
      eigyoshoList: 'DDMasters/mstEigyosho',
      kubunList: 'DDMasters/msysKubun'
    }),
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      })
    },
    filteredYearList () {
      const goBackYears = 10
      const currentYear = new Date().getFullYear()
      const yearList = []

      // 来年から過去10年分までをループで処理
      for (let year = currentYear + 1; year >= currentYear - goBackYears; year--) {
        yearList.push(String(year))
      }

      return yearList
    },
    // 燃料区分フィルター
    filteredNenryoKubunList () {
      const self = this
      return self.kubunList.filter(function (elem) {
        return elem.kbnShuruiCd === 'SFF053' && elem.kaishaCd === self.currentKaishaCode
      })
    },
    computedColNumList () {
      var result = {}
      this.headers.forEach((elem, index) => {
        result[elem.name] = index
      })
      return result
    },
    isMultiSaveButtonDisabled () {
      if (this.modeKengen !== 2) {
        return false
      }
      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true
      })
      if (saveTargetRow.length < 1) {
        return true
      }
      return false
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'msyskubun'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onClearButtonClick: function () {
      this.isSearched = false
      this.clear()
    },
    clear: function () {
      this.initBindVariables()
    },
    onSearchButtonClick: function () {
      // dd-spread-sheetを非表示にしてコンポーネントを破棄する(エラーがあると。mixinで処理が中断されるため)
      this.isSearched = false
      this.rows = []
      this.isSearched = true
      this.searchedYm = this.conditions.targetYear
      this.searchedEigyoshoCd = this.conditions.eigyoshoCd
      this.$nextTick(() => {
        this.searchAction(false)
      })
    },
    searchAction: function (noMessage) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCMstKyuyuTanka/search', self.conditions)
              .then((data) => {
                self.setHeader()
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          const resultData = data.payload
          // 表示領域初期化
          self.rows = []

          // mapの戻り値（新しい配列）をsearchResultRowに格納する
          self.searchResultRow = resultData.map((elem, index) => {
            // 元のelemのコピーを作成し、新しいプロパティを追加する
            const newElem = {
              ...elem, // 元のオブジェクトのプロパティをすべてコピー
              rowNo: index + 1,
              editFlg: false
            }

            // 1月から12月までのtankaプロパティを処理する
            for (let i = 1; i <= 12; i++) {
              const propName = `month${i}Tanka`
              if (newElem[propName]) {
                // newElemに対してフォーマットを適用
                newElem[propName] = filter.numericFormatter(newElem[propName])
              } else {
                // newElemになければプロパティを追加
                newElem[propName] = ''
              }
            }
            // 変更が加えられた新しいオブジェクトを返す
            return newElem
          })

          // 新しく生成された配列のコピーをrowsにセットする
          self.rows = [...self.searchResultRow] // こちらもスプレッド構文が推奨
        },
        isNoMessageModeMethod: function () {
          return noMessage
        },
        getSavedInputMethod: function () {
          return {}
        },
        failureValidateMethod: function () {
          self.torikomiConditonsRequired = true
          self.tableRowRequired = true
        }
      }
      this.search(opt)
    },
    // 検索前チェック
    searchValidate: function () {
      return true
    },

    /**
     * ヘッダー定義
     */
    setHeader () {
      const self = this
      return new Promise(resolve => {
        var wkNenryoKbnList = ['未選択']
        const mNenryoKbnList = self.kubunList.filter((t) => {
          return t.delFlg === false && t.kbnShuruiCd === 'SFF053'
        })
        const tNenpiCategoryList = mNenryoKbnList.map(elem => {
          return elem.codeNm
        })
        wkNenryoKbnList = wkNenryoKbnList.concat(tNenpiCategoryList)
        // ヘッダー定義
        self.headers = [
          // コードは自動発番にして名称で判別させる？
          { title: 'コード', name: 'kyuyuSbtCd', validateType: 'Free', validateLength: 50, required: false, readOnly: false, width: '60px' },
          { title: '名称', name: 'kyuyuSbtNm', validateType: 'Free', validateLength: 50, required: false, readOnly: false, width: '150px' },
          { title: '燃料区分', name: 'fuelKbnNm', type: 'dropdown', customInput: null, source: wkNenryoKbnList, required: true, width: '100px', autocomplete: true }
        ]
        const japaneseMonths = ['１月', '２月', '３月', '４月', '５月', '６月', '７月', '８月', '９月', '１０月', '１１月', '１２月']
        let startMonth = 4 // 期初月（1=1月, 4=4月など）
        if (self.kihonJohoList.length > 0) {
          startMonth = self.kihonJohoList[0].kessanMonth + 1 || 4 // 基本情報から取得、なければ4月
          if (startMonth > 12) {
            startMonth = 1 // 12月を超えたら1月に戻す
          }
        }
        for (let i = 0; i < 12; i++) {
          const monthIndex = (startMonth - 1 + i) % 12
          const monthName = `month${monthIndex + 1}Tanka` // name: month1Tanka ~ month12Tanka
          const monthTitle = japaneseMonths[monthIndex]

          self.headers.push({
            title: monthTitle,
            name: monthName,
            type: 'numeric',
            validateIntDigit: 14,
            validateDecimalDigit: 2,
            readOnly: false,
            align: 'right',
            width: '90px',
            mask: '#,##0.00 円'
          })
        }

        // ネストヘッダ
        const wTargetPeriod = self.conditions.targetYear
        self.nestedHeaders = [
          [
            { title: '給油会社', colspan: 2 },
            { title: '', colspan: 1 },
            { title: `${wTargetPeriod}年度給油単価（円）`, colspan: 12 }
          ]
        ]

        resolve()
      })
    },
    // 行追加 上
    rowAppendAvobe: function (num) {
      this.rowAppend(num, true)
    },
    // 行追加
    rowAppend: function (num, aboveFlg) {
      // 現在の選択セル
      var activeC = this.$refs.ddSpreadSheet.getActiveCell()
      // 行追加先の位置を取得
      var pos = 0
      // 全選択状態なら先頭行に追加
      var isAllSelect = false
      if (!activeC) {
        // セル未選択
      } else if (activeC.length > 3) {
        // セル選択
        pos = Math.max(...[activeC[1], activeC[3]]) + 1

        // 全選択かどうか判定
        var isSame1 = activeC[0] === 0
        var isSame2 = activeC[1] === 0
        var isSame3 = activeC[2] === this.headers.length - 1
        var isSame4 = activeC[3] === this.rows.length - 1
        isAllSelect = isSame1 && isSame2 && isSame3 && isSame4
      }

      var newrow = this.setNewRow()

      // 行追加
      if (isAllSelect || (aboveFlg !== undefined && aboveFlg)) {
        if (pos === 0) {
          this.rows.unshift(newrow)
          pos = 0
        } else {
          this.rows.splice(pos - 1, 0, newrow)
          pos = pos - 1
        }
      } else {
        if (![undefined, null].includes(pos)) {
          this.rows.splice(pos, 0, newrow)
        } else {
          this.rows.splice(this.rows.length, 0, newrow)
        }
      }

      // 行番号が狂うので外部からのエラー設定は消去
      this.outsideErrorList = []

      // 行追加後のセルを選択状態にしてあげる…準備
      this.selectTargetPosition = pos + 1
    },
    setNewRow () {
      return {
        kyuyuSbtCd: null,
        kyuyuSbtNm: null,
        fuelKbnNm: '軽油',
        eigyoshoCd: this.searchedEigyoshoCd,
        kessanNendo: this.searchedYm,
        month1Tanka: null,
        month2Tanka: null,
        month3Tanka: null,
        month4Tanka: null,
        month5Tanka: null,
        month6Tanka: null,
        month7Tanka: null,
        month8Tanka: null,
        month9Tanka: null,
        month10Tanka: null,
        month11Tanka: null,
        month12Tanka: null,
        editFlg: true
      }
    },

    onNewRowButtonClick: function (e) {
      this.rowAppend(1)
    },
    onMultiSaveButtonClick: function () {
      const self = this
      // 変更フラグONかつ燃料区分≠Nullのもののみ対象
      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true && !['', null, undefined].includes(elem.fuelKbnNm)
      })
      if (saveTargetRow.length < 1) { return }

      /**
       * リスト項目テキスト⇒ID/Code変換
       */
      // 燃料区分変換
      saveTargetRow.map((elem) => {
        const m = self.filteredNenryoKubunList.filter(function (item) {
          return item.codeNm === elem.fuelKbnNm
        })
        if (m.length > 0) {
          elem.fuelKbn = m[0].code
        }
        return elem
      })

      this.targetKyuyuTankaList = saveTargetRow
      this.$nextTick(function () {
        self.saveKyuyuTankaAction()
      })
    },
    saveKyuyuTankaAction: function () {
      this.Effects.loadStart()
      const self = this
      const opt = {
        registerRequestPromise: function () {
          return self.HttpClient.post('/api/v1/VwCMstKyuyuTanka/BulkRegister', self.targetKyuyuTankaList)
        },
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.Effects.loadComplete()

            this.$nextTick(function () {
              self.targetKyuyuTankaList = []
              self.searchAction(true)
            })
            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        isNoMessageModeMethod: function () {
          return false
        },
        getSavedInputMethod: function () {
          return true
        }
      }
      this.register(opt)
    },
    registerValidate: function () {
      return true
    },
    onXlsOutputButtonClick: function (e) {
      this.isXlsDownloader = true

      this.HttpClient
        .requestFileByPost('/api/v1/VwCMstKyuyuTanka/ExcelOutput', this.conditions)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('xlsdownload')
          this.isXlsDownloader = false
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '給油単価設定_' + ts + '.xlsx'
          elem.click()
        })
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      this.conditions = {
        targetYear: String(new Date().getFullYear()),
        eigyoshoCd: null
      }
      this.searchedYm = null
      this.searchedEigyoshoCd = null
      this.targetKyuyuTankaList = []
      this.searchText = ''
      this.rows = []
      this.page = 1
    }
  }
}
